import { render } from "./Viewer.vue?vue&type=template&id=dcef040a&scoped=true"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"

import "./Viewer.vue?vue&type=style&index=0&id=dcef040a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dcef040a"

export default script